import { get } from 'lodash';

import { MaasModelSourceType } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';

/** 判断来源类型是否已有有效核心字段（忽略空占位块，避免 hidden 字段误判为 Http/S3） */
export function hasModelSourceCore(source: Record<string, unknown>, type: MaasModelSourceType): boolean {
  switch (type) {
    case MaasModelSourceType.Http:
      return !!String(get(source, 'http.url') || '').trim();
    case MaasModelSourceType.S3:
      return !!String(get(source, 's3.url') || '').trim();
    case MaasModelSourceType.ModelScope:
      return !!String(get(source, 'modelscope.model') || '').trim();
    case MaasModelSourceType.HuggingFace:
      return !!String(get(source, 'huggingface.model') || '').trim();
    case MaasModelSourceType.StackScope:
      return !!String(get(source, 'stackscope.model') || '').trim() && !!String(get(source, 'stackscope.url') || '').trim();
    case MaasModelSourceType.ModelPlaza:
      return !!String(get(source, 'modelplaza.model') || '').trim() && !!String(get(source, 'modelplaza.url') || '').trim();
    default:
      return false;
  }
}
